export const eventConstants = {
    TOGGLE_EVENT_LANGUAGE: 'TOGGLE_EVENT_LANGUAGE',

    GET_EVENT_LIST_REQUEST: 'GET_EVENT_LIST_REQUEST',
    GET_EVENT_LIST_SUCCESS: 'GET_EVENT_LIST_SUCCESS',
    GET_EVENT_LIST_FAILURE: 'GET_EVENT_LIST_FAILURE',
   
    GET_EVENT_REQUEST: 'GET_EVENT_REQUEST',
    GET_EVENT_SUCCESS: 'GET_EVENT_SUCCESS',
    GET_EVENT_FAILURE: 'GET_EVENT_FAILURE',

    GET_EVENT_SETTINGS_REQUEST: 'GET_EVENT_SETTINGS_REQUEST',
    GET_EVENT_SETTINGS_SUCCESS: 'GET_EVENT_SETTINGS_SUCCESS',
    GET_EVENT_SETTINGS_FAILURE: 'GET_EVENT_SETTINGS_FAILURE',

    UPDATE_EVENT_REQUEST: 'UPDATE_EVENT_REQUEST',
    UPDATE_EVENT_SUCCESS: 'UPDATE_EVENT_SUCCESS',
    UPDATE_EVENT_SETTINGS_SUCCESS: 'UPDATE_EVENT_SETTINGS_SUCCESS',
    UPDATE_EVENT_FAILURE: 'UPDATE_EVENT_FAILURE',

    CREATE_EVENT_REQUEST: 'CREATE_EVENT_REQUEST',
    CREATE_EVENT_SUCCESS: 'CREATE_EVENT_SUCCESS',
    CREATE_EVENT_FAILURE: 'CREATE_EVENT_FAILURE',

    DELETE_EVENT_REQUEST: 'DELETE_EVENT_REQUEST',
    DELETE_EVENT_SUCCESS: 'DELETE_EVENT_SUCCESS',
    DELETE_EVENT_FAILURE: 'DELETE_EVENT_FAILURE',
};